import React from 'react'

const ShoppingCartContext = React.createContext({
  /* Default Shopping Cart State */
})

export default ShoppingCartContext
